module.exports = __webpack_public_path__ + "static/media/OMG_2.402169b5.svg";